import grapesjs from 'drapcode-builder';
import loadTraits from './traits';

export default grapesjs.plugins.add('webconnect-collection-img-traits', (editor, opts) => {
  const default_traits = {
    link: {
      type: 'webconnect-image',
      label: false,
    },
  };
  let options = {
    ...{
      traits: default_traits,
    },
    ...opts,
  };
  loadTraits(editor, options);
});
